import Vue from 'vue'
import VueRouter from 'vue-router'
// import designer from '@/components/formDesigner'
// import dialogTest from '@/pages/dialogTest'
// import queryDialogTest from '@/pages/queryDialogTest'
import view from '@/pages/view'
// import table from '@/pages/table'


Vue.use(VueRouter)

const routes = [
  {
    path: '/designer',
    name: 'designer',
    component: () => import("@/components/formDesigner")
  },
  {
    path: '/dialog',
    name: 'dialogTest',
    component: () => import("@/pages/dialogTest")
  },
  {
    path: '/start_form',
    name: 'start_form',
    component: () => import("@/pages/start_form")
  },
  {
    path: '/start_flow_form',
    name: 'start_flow_form',
    component: () => import("@/pages/start_flow_form")
  },
  {
    path: '/start_data_form',
    name: 'start_data_form',
    component: () => import("@/pages/start_data_form")
  },
  {
    path: '/view_form_data',
    name: 'view_form_data',
    component: () => import("@/pages/view_form_data")
  },
  {
    path: '/test_page',
    name: 'test_page',
    component: () => import("@/pages/TestPage")
  },
  // {
  //   path: '/queryDialog',
  //   name: 'queryDialogTest',
  //   component: queryDialogTest
  // },
  {
    path: '/view',
    name: 'view',
    component: view
  },
  {
    path: '/start_form_open',
    name: 'start_form_open',
    component: () => import("@/pages/start_form_open")
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import("@/pages/Success.vue")
  },
  // {
  //   path: '/table',
  //   name: 'table',
  //   component: table
  // }
]

const router = new VueRouter({
  routes
})

export default router
